import { ActionIcon, Tooltip } from '@mantine/core';
import {
  IconLayoutSidebarLeftCollapse,
  IconLayoutSidebarLeftExpand,
} from '@tabler/icons-react';
import { useNavBar } from '../../store/navBarState';
import * as classes from './styles/index.css';

export default function NavBarToggleButton() {
  const navBar = useNavBar();
  const Icon = navBar.isCollapsed
    ? IconLayoutSidebarLeftExpand
    : IconLayoutSidebarLeftCollapse;

  return (
    <Tooltip
      label={navBar.isCollapsed ? 'Expand navigation' : 'Collapse navigation'}
      position="right"
    >
      <ActionIcon
        className={classes.button}
        onClick={navBar.toggleState}
        aria-label={
          navBar.isCollapsed ? 'Expand navigation' : 'Collapse navigation'
        }
      >
        <Icon size={18} />
      </ActionIcon>
    </Tooltip>
  );
}
